import { useState, useRef } from "react";

export function useMergedSelectFieldState() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  // Use useRef tipado do React
  const inputRef = useRef<HTMLDivElement | null>(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const nativeSelectRef = useRef<HTMLSelectElement | null>(null);

  return {
    isDropdownOpen,
    setIsDropdownOpen,
    isFocused,
    setIsFocused,
    highlightedIndex,
    setHighlightedIndex,
    inputRef,
    dropdownRef,
    nativeSelectRef,
  };
}